import React, { useState } from "react";

const stabilityGroups = {
  "Stability Tests": [
    { key: "acceleratedStability", label: "Accelerated Stability" },
    { key: "realTimeStability", label: "Real Time Stability" },
    { key: "oxidativeStability", label: "Oxidative Stability" },
    { key: "photoStability", label: "Photo Stability" },
    { key: "radiationStudy", label: "Radiation Study" },
  ],
  "Functional Recommendation": [
    { key: "shelfLife", label: "Shelf Life" },
    { key: "handling", label: "Handling" },
    { key: "capsule", label: "Capsule" },
    { key: "tablet", label: "Tablet" },
    { key: "foodPreparations", label: "Food Preparations" },
    { key: "cosmeticPreparations", label: "Cosmetic Preparations" },
    { key: "mixability", label: "Mixability" },
  ],
};

export default function StabilityInformationForm({ data, onChange, onNext, onBack }) {
  const processes = data.processes || [];
  const [selectedIndex] = useState(processes.length > 0 ? 0 : -1);

  const setProcessField = (key, value) => {
    if (selectedIndex < 0) return;
    const updatedProcesses = [...processes];
    const currentProcess = { ...updatedProcesses[selectedIndex] };
    currentProcess[key] = value;
    updatedProcesses[selectedIndex] = currentProcess;
    onChange("processes", updatedProcesses);
  };

  return (
    <div>
      <h4 className="text-success">Stability Information</h4>

      {processes.length === 0 ? (
        <div className="alert alert-warning">No processes added yet. Please go back.</div>
      ) : (
        <>
          {selectedIndex >= 0 && (
            <div>
              {Object.entries(stabilityGroups).map(([group, fields]) => (
                <div key={group} className="card mb-4 shadow-sm">
                  <div className="card-header bg-light">
                    <h5 className="mb-0 text-primary">{group}</h5>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      {fields.map(({ key, label }) => (
                        <div className="col-md-6 mb-3" key={key}>
                          <label className="form-label fw-bold">{label}</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder={`Enter ${label}`}
                            value={processes[selectedIndex]?.[key] ?? ""}
                            onChange={(e) => setProcessField(key, e.target.value)}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}

      <div className="d-flex justify-content-between mt-3">
        <button className="btn btn-secondary" onClick={onBack}>
          Back
        </button>
        <button className="btn btn-primary" onClick={onNext}>
          Next
        </button>
      </div>
    </div>
  );
}